import { Component, Input } from '@angular/core';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';

@Component({
	selector: 'app-overflow-chip-list',
	template: ` @if (showPrimaryChip) {
		<mat-chip-listbox>
			<mat-chip-option
				class="primary-chip chip-group-name-color"
				data-automation-id="primary-chip"
				><div class="primary-chip-no-wrap">
					{{ primaryChipLabel }}
				</div></mat-chip-option
			>
			@if (showOverflowChip) {
				<mat-chip-option
					class="overflow-chip"
					data-automation-id="overflow-chip"
					>{{ overflowChipLabel }}</mat-chip-option
				>
			}
		</mat-chip-listbox>
	}`,
	styleUrls: ['./overflow-chip-list.component.scss'],
	imports: [MatChipListbox, MatChipOption],
})
export class OverflowChipListComponent {
	@Input() chips!: string[];

	get showPrimaryChip(): boolean {
		return this.chips?.length > 0;
	}

	get primaryChipLabel(): string {
		return this.showPrimaryChip ? this.chips[0] : '';
	}

	get showOverflowChip(): boolean {
		return this.chips?.length > 1;
	}

	get overflowChipLabel(): string {
		return this.showOverflowChip ? `+${this.chips.length - 1}` : '';
	}

	constructor() {}
}
